import { render } from "./emoji_picker.vue?vue&type=template&id=45728bd6"
import script from "./emoji_picker.js?vue&type=script&lang=js"
export * from "./emoji_picker.js?vue&type=script&lang=js"

import "./emoji_picker.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/builds/pleroma/pleroma-fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__